module.exports = __webpack_public_path__ + "static/media/anna-kolesnikova.b4ac5f50.jpeg";